// Feature flags for the application
// These are build-time flags that can be controlled via environment variables

export const FEATURES = {
  // Controls whether the Assignments Review features are enabled
  ASSIGNMENTS_REVIEW_ENABLED:
    process.env.REACT_APP_ASSIGNMENTS_REVIEW_ENABLED === "true",
} as const;
